export default __webpack_public_path__ + "static/media/vr-illustration-tick.ffbb5b88.svg";